import { atom } from 'jotai';
import { PageType } from '@/types/pageType';

/**
 * Set by `PageTypeSetter` for pages whose chrome cannot be derived from the
 * pathname: the page type on CMS pages (where an editor picks it in Amplience),
 * or hiding the promo banner on the designer page when it was opened with a
 * POTM coupon (`?potm_coupon=`). Only the fields a page sets override the
 * route-derived chrome.
 *
 * Keyed by the URL the page was rendered for. The page shell stays mounted
 * across navigations and the setter can only clear the atom from its effect
 * cleanup, which runs *after* the next route has already rendered — an unkeyed
 * override would leak into that route for at least one paint. `null`, or a
 * pathname that is no longer the current one, both mean "derive from the route"
 * — see `usePageChrome`.
 */
export type PageTypeOverride = {
  pathname: string;
  pageType?: PageType;
  hidePromoBanner?: boolean;
};

export const pageTypeOverrideAtom = atom<PageTypeOverride | null>(null);
